import { Component, AfterViewInit, inject, ChangeDetectorRef, Input, EventEmitter, Output, HostListener } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { environment } from '../../environments/environment'
import { CommonModule } from '@angular/common';
import { Service } from '../../service/service';
import { TranslocoService, TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-map',
  standalone: true,
  templateUrl: './maps.html',
  imports: [TranslocoModule, CommonModule] 
})
export class MapComponent implements AfterViewInit {
  @Input() externalLocations: any[] = [];
  @Output() onTotalChanged = new EventEmitter<number>();

  private cdr = inject(ChangeDetectorRef);
  private map!: mapboxgl.Map;
  private service = inject(Service);
  public locations: any[] = [];
  public totalLocations: number = 0;
  public loadCompleted: number = 0;

  constructor(
      private readonly translocoService: TranslocoService
    ) {}

  zoomToLocation(place: any): void {
    if (this.map && place.centroid) {
      this.map.flyTo({
        center: [place.centroid.longitude, place.centroid.latitude],
        zoom: 16,
        essential: true
      });
    }
  }

  changelanguage(lang: string) {
    this.translocoService.setActiveLang(lang);
  }

  @HostListener('window:resize')
  onWindowResize() {
    if (this.map) {
      this.map.resize();
    }
  }

  ngAfterViewInit() {
    if (this.externalLocations.length > 0) {
      this.locations = this.externalLocations;
    }

    this.service.getLocations().subscribe({
      next: (data) => {
        this.locations = (data as any)['results'];
        this.totalLocations = (data as any)['total'];
        this.onTotalChanged.emit(this.totalLocations);
        this.startMap();
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Erro carregando a API', err);
        this.startMap();
      }
    });
  }

  startMap() {

    if (!this.locations || this.locations.length === 0) return;


    const token = environment.mapboxToken;

    this.map = new mapboxgl.Map({
      container: 'map',
      accessToken: token,
      style: 'mapbox://styles/mapbox/streets-v12',
      center: [-8.435948937260475, 39.91165166500956],
      zoom: 14
    });

    
    this.map.addControl(new mapboxgl.NavigationControl());


    const bounds = new mapboxgl.LngLatBounds();
    if (this.locations && this.locations.length > 0) { 
      this.locations.forEach(place => {
        if (place.centroid != undefined) {
          const coords: [number, number] = [place.centroid.longitude, place.centroid.latitude];
          bounds.extend(coords);
          const popup = new mapboxgl.Popup({ offset: 25 })
            .setHTML(`<h3>${place.identifier}</h3>`);
          
          const img = document.createElement('img');
            img.className = 'Marker';
            img.src = './img/pin-marker.png';
            img.style.width = '40px';
            img.style.cursor = 'pointer';
            new mapboxgl.Marker({
              element: img,
              anchor: 'bottom'
            })
              .setLngLat([place.centroid.longitude, place.centroid.latitude])
              .setPopup(popup)
              .addTo(this.map);
        }
      });
    }

    this.loadCompleted++;
    this.cdr.detectChanges();
    this.map.fitBounds(bounds, {
      padding: 50,    
      duration: 7000, 
      maxZoom: 17
    });
  }
  
}


